import { AbstractService } from '../services/abstract.service';
import { UserModel } from '../../dashboard/profile/models/user.model';
import { InviteUserModel } from '../../dashboard/profile/models/invite-user.model';
import { Observable } from 'rxjs';
import { SupportRequestModel } from '../help/help.model';
import { Injectable } from '@angular/core';
import { UsersState } from './xs/users.state';

@Injectable({ providedIn: 'root' })
export class UsersService extends AbstractService {
  // eslint-disable-next-line @typescript-eslint/ban-types
  inviteUsers(users: InviteUserModel[], companyType: string, companyId: string | 'this' = 'this'): Observable<Object> {
    /* eslint-disable @typescript-eslint/indent */
    switch (companyType) {
      default:
      case 'sme':
        return this.inviteUsersSme(users, companyId);
      case 'enterprise':
        return this.inviteUsersEnterprise(users, companyId);
    }
    /* eslint-enable @typescript-eslint/indent */
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  inviteUsersSme(users: InviteUserModel[], companyId: string | 'this' = 'this'): Observable<Object> {
    if (companyId === 'this' || companyId == null) {
      return this.http.post(`${this.apiBaseUrl}/companies/invite-more`, users);
    }

    return this.http.post(`${this.apiBaseUrl}/companies/${companyId}/invite-more`, users);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  inviteUsersEnterprise(users: InviteUserModel[], enterpriseId: string | 'this' = 'this'): Observable<Object> {
    if (enterpriseId === 'this' || enterpriseId == null) {
      return this.http.post(`${this.apiBaseUrl}/enterprises/invite-more`, users);
    }

    return this.http.post(`${this.apiBaseUrl}/enterprises/${enterpriseId}/invite-more`, users);
  }

  async deleteUser(userId: string): Promise<void> {
    await this.http.delete(`${this.apiBaseUrl}/users/${userId}/delete`).toPromise();
  }

  async getOtherUsersOf(companyType: string, id: 'this' | string = 'this'): Promise<UserModel[]> {
    switch (companyType) {
      default:
      case 'sme':
        return id === 'this' ? this.getOtherUsersOfCurrentCompany() : this.getUsersOfCompany(id);
      case 'enterprise':
        return id === 'this' ? this.getOtherUsersOfCurrentEnterprise() : this.getUsersOfEnterprise(id);
    }
  }

  async getUsersOfCompany(companyId: string): Promise<UserModel[]> {
    const result = await this.http.get(`${this.apiBaseUrl}/companies/${companyId}/users`).toPromise();

    return result as UserModel[];
  }

  async getOtherUsersOfCurrentCompany(): Promise<UserModel[]> {
    const result = await this.http.get(`${this.apiBaseUrl}/users/current-company/other-users`).toPromise();

    return result as UserModel[];
  }

  async getAllUsersOfCurrentCompany(): Promise<UserModel[]> {
    const result = await this.http.get(`${this.apiBaseUrl}/users/current-company/all-users`).toPromise();

    return result as UserModel[];
  }

  async getUsersOfEnterprise(enterpriseId: string): Promise<UserModel[]> {
    const result = await this.http.get(`${this.apiBaseUrl}/enterprises/${enterpriseId}/users`).toPromise();

    return result as UserModel[];
  }

  async getOtherUsersOfCurrentEnterprise(): Promise<UserModel[]> {
    const result = await this.http.get(`${this.apiBaseUrl}/users/current-enterprise/other-users`).toPromise();

    return result as UserModel[];
  }

  async sendHelpRequest(payload: SupportRequestModel): Promise<void> {
    await this.http.post(`${this.apiBaseUrl}/support/help`, payload).toPromise();
  }

  getUsersToInvite(): InviteUserModel[] {
    return this.store.selectSnapshot(UsersState.inviteUsers);
  }
}
